import { jsx } from "react/jsx-runtime";
import PaymentsIcon from "@mui/icons-material/Payments";
import { validateTidalLicense } from "../../base/index.js";
function Payments(props) {
  return /* @__PURE__ */ jsx(
    PaymentsIcon,
    {
      "data-testid": "Payments",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Payments",
      "data-tidal-icon-meta": "money,invoices,payments"
    }
  );
}
Payments.tidalIconMeta = {
  categories: "money,invoices,payments",
  name: "Payments"
};
validateTidalLicense();
export {
  Payments
};
//# sourceMappingURL=Payments.js.map
